import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import CookiesConsent from "./components/cookies-consent";
import NewsletterForm from "./components/newsletter-form";
import DeviceManager from "./utils/device-manager";


(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));


		// BU Product slider component
		const $buProductSlider = $(".bu-products-slider");
		if ($buProductSlider.length) {
			$buProductSlider.each(function (index, el) {
				const buProductSlider = new BUProductSlider($(el));
			});
		}

		// Newsletter form component
		const $newsletterFormElements = $(".footer-block.footer-block--newsletter-style");
		if ($newsletterFormElements.length) {
			$newsletterFormElements.each(function (index, el) {
				const newsletterForm = new NewsletterForm(el);
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		$('.slide-partenaire').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			autoplay: true
		  });
		$('.marque-slide').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			autoplay: true,
			dots: true,
		});
		$('.items-client-2').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			// autoplay: true,
			adaptiveHeight: true,
			dots: true,
		});
		$('.slideshow').slick({
			infinite: true,
			slidesToShow: 1,
			arrows: true,
			adaptiveHeight: true,
		});
		$('.items-client').slick({
			infinite: true,
			slidesToShow: 5,
			adaptiveHeight: true,
			dots: true,

		});
		  

	});
})(jQuery);
